import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Role } from '../../../../../core/auth';

@Component({
  selector: 'kt-agreement-edit-dialog',
  templateUrl: './agreement-edit.dialog.component.html',
  styleUrls: ['./agreement-edit.dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AgreementEditDialogComponent {
  // Public properties
  role: Role;
  hasFormErrors = false;
  hasSubmissionErrors = false;
  submissionErrorObj: any;
  viewLoading = false;
  loadingAfterSubmit = false;
  isSuperAdmin: boolean;
  roleTitle;

  /**
   * Component constructor
   *
   * @param dialogRef
   * @param data
   */
  constructor(
    public dialogRef: MatDialogRef<AgreementEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  /**
   * Save data
   */
  onSubmit() {
    this.hasFormErrors = false;
    this.loadingAfterSubmit = false;
  }

  /**
   * Close alert
   *
   */
  onAlertClose() {
    this.hasFormErrors = false;
  }
  /** UI */
  /**
   * Returns component title
   */
  getTitle(): string {
    if (this.role && this.role.id) {
      // tslint:disable-next-line:no-string-throw
      return 'AGREEMENT.EDIT_AGREEMENT';
    }

    // tslint:disable-next-line:no-string-throw
    return 'AGREEMENT.NEW_AGREEMENT';
  }

  /**
   * Returns is title valid
   */
  isTitleValid(): boolean {
    return this.role && this.role.title && this.role.title.length > 0;
  }
}
